import React, { useState } from 'react';
import './index.css';
import a2bLogo from './Pictures/newlogo.png';

function About() {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="flex flex-col md:flex-row justify-between items-center">
      <div className="w-full md:w-2/3">
        <div className="p-6 text-left md:pl-28 text-center md:text-left">
          <h2 className="text-3xl font-extrabold mb-6">Black Car Service</h2>
          <h2 className="text-2xl font-extrabold mb-6">Let Us Handle Your Transportation Needs</h2>
          <p className="mb-6 text-lg leading-relaxed transition-all duration-500 ease-in-out">
            We specialize in corporate limousine accounts, airport pick up and drop off service, tours and personal transportation.
            Our business model is built on prompt delivery of our clients to their desired destination, whether it be the airport, business meeting or any event whether it's in New York, New Jersey, Connecticut in the Tristate area.
            A2B Corporate Sedan provides transportation 24 hours a day, 365 days a year.
            All of our vehicles are completely licensed and insured.
          </p>
          {isExpanded && (
            <p className="mb-6 text-lg leading-relaxed transition-all duration-500 ease-in-out">
              Please select from our luxury sedans, SUV, Limousines, Stretch Limo, Vans & Shuttle Buses.
              Also ask about our Wedding Packages in our Beautiful Limousines, business limousine service in NYC, night out on the town.
              We are proud to call ourselves one of the oldest and best New York City's limousine companies.
            </p>
          )}
          <button onClick={toggleReadMore} className="text-blue-500 hover:text-blue-700 text-lg font-bold">
            {isExpanded ? 'Read less...' : 'Read more...'}
          </button>
        </div>
      </div>
      <div className="w-full md:w-1/3 flex justify-center">
        <img src={a2bLogo} alt="A2B Logo" className="w-0 md:w-52 h-auto" />
      </div>
    </div>
  );
}

export default About;